// Mock data and API functions for Tara Ventures website
// This simulates backend functionality for the contact form

// Simulate form submission
export const submitContactForm = async (formData) => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1000));

  // Validate form data
  if (!formData.name || !formData.email || !formData.message) {
    throw new Error('Please fill in all required fields');
  }

  // Simulate email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formData.email)) {
    throw new Error('Please enter a valid email address');
  }

  // Log form submission (in real app, this would be sent to backend)
  console.log('Contact Form Submitted:', {
    ...formData,
    timestamp: new Date().toISOString(),
    status: 'pending'
  });

  // Store in localStorage for demo purposes
  try {
    const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
    submissions.push({
      ...formData,
      id: Date.now(),
      timestamp: new Date().toISOString(),
      status: 'pending'
    });
    localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
  } catch (error) {
    console.error('Error storing submission:', error);
  }

  return {
    success: true,
    message: 'Thank you for your message. We will respond within 48 hours.',
    submissionId: Date.now()
  };
};

// Get all contact form submissions (for demo/testing)
export const getContactSubmissions = () => {
  try {
    return JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
  } catch (error) {
    console.error('Error retrieving submissions:', error);
    return [];
  }
};

// Clear all submissions (for demo/testing)
export const clearContactSubmissions = () => {
  localStorage.removeItem('contactSubmissions');
  console.log('All contact submissions cleared');
};